import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";

const StyledContact = styled.div`
  display: flex;
  flex-direction: column;
`;

function ContactInfo() {
  const { configStore } = useStores();
  const { contact } = configStore.config;

  if (isEmpty(contact)) {
    return null;
  }

  return (
    <StyledContact>
      {contact.phoneNumber && (
        <p className="mb-2">
          TELEPHONE:{" "}
          <a href={`tel:${contact.phoneNumber}`}>{contact.phoneNumber}</a>
        </p>
      )}
      {contact.email && (
        <p className="mb-2">
          EMAIL: <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
      )}
    </StyledContact>
  );
}

export default observer(ContactInfo);
